import "./styles.scss";

export default function DBTab({
    tabs,
    selected,
    onChange,
    color,
    tabExtras,
}) {
    return (
        <div className="db-tabs">
            <div>
                <div>
                    {tabs.map((tab, index) => (
                        <div key={index} className="db-tab-item">
                            <button
                                onClick={() => onChange(index)}
                                style={{
                                    borderColor: color,
                                    color: selected === index ? color : "#333",
                                }}
                                className={selected === index ? "selected" : ""}
                            >
                                {tab}
                            </button>
                            {tabExtras?.[index]}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
